import { observer } from 'mobx-react';
import ParticipantsStore from '../../../../../../../../../ParticipantsStore';
import { T } from '../../../../../../../../../Translations';
import Row from './Row';

interface Props {
  store: ParticipantsStore;
}

function CheckedParticipantsList({ store }: Props) {
  return (
    <div className="mb-8">
      <div className="text-md font-semibold">
        <T kind="Participants to be added to group" />
      </div>
      <div className="md:max-h-[30vh] md:h-[30vh] sm:max-h-[20vh] sm:h-[20vh] text-sm overflow-y-auto">
        {store.checkedParticipants.map((participantStore) => (
          <Row store={participantStore} key={participantStore.resource.payload.id} />
        ))}
      </div>
    </div>
  );
}

export default observer(CheckedParticipantsList);
